import { Dispatch, SetStateAction } from 'react';
import {
  ToolsRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

interface UserReportsMenuProps {
  anchorEl: null | HTMLElement;
  open: boolean;
  handleClose: () => void;
  setOpenReportsDialog: (open: boolean) => void;
  setSelectedReport: Dispatch<
    SetStateAction<{
      displayName: string;
      reportType: string;
      role: string;
    } | null>
  >;
  toolsRoles: string[];
}

const reports = [
  {
    displayName: 'Approved Email Forwarding',
    reportType: 'approvedEmailForwardingReport',
    role: ToolsRoles.RunApprovedEmailForwardingReport.value,
  },
  {
    displayName: 'Archive Users',
    reportType: 'archiveUsers',
    role: ToolsRoles.RunArchivedUsersReport.value,
  },
  {
    displayName: 'Email Delegate',
    reportType: 'emailDelegate',
    role: ToolsRoles.RunEmailDelegateReport.value,
  },
  {
    displayName: 'Email Forwarding',
    reportType: 'emailForwarding',
    role: ToolsRoles.RunEmailForwardingReport.value,
  },
  {
    displayName: 'Email Monitor',
    reportType: 'emailMonitor',
    role: ToolsRoles.RunEmailMonitoringReport.value,
  },
  {
    displayName: 'Export Personal Contacts',
    reportType: 'exportPersonalContacts',
    role: ToolsRoles.RunExportPersonalContactsReport.value,
  },
  {
    displayName: 'Externally Owned Docs',
    reportType: 'externallyOwnedDocs',
    role: ToolsRoles.RunExternallyOwnedDocsReport.value,
  },
  {
    displayName: 'Gmail Breakdown Report',
    reportType: 'gmailBreakdownReport',
    role: ToolsRoles.RunGmailBreakdownReport.value,
  },
  {
    displayName: 'Last Login',
    reportType: 'lastLogin',
    role: ToolsRoles.RunLoginReport.value,
  },
  {
    displayName: 'License Types',
    reportType: 'licenseTypes',
    role: ToolsRoles.RunLicenseTypes.value,
  },
  {
    displayName: 'Send as Addresses',
    reportType: 'sendAsReport',
    role: ToolsRoles.RunSendAsAddresses.value,
  },
  {
    displayName: 'Site Ownership',
    reportType: 'siteOwnership',
    role: ToolsRoles.RunSiteOwnership.value,
  },
  {
    displayName: 'Storage Report',
    reportType: 'storageReport',
    role: ToolsRoles.RunStorageReport.value,
  },
  {
    displayName: 'Super Admin',
    reportType: 'superAdmin',
    role: ToolsRoles.RunSuperAdminReport.value,
  },
  {
    displayName: 'Suspended User',
    reportType: 'suspendedUser',
    role: ToolsRoles.RunSuspendedReport.value,
  },
  {
    displayName: 'Two Factor Enrolled',
    reportType: 'twoFactorEnrolled',
    role: ToolsRoles.RunTwoFactorEnrolled.value,
  },
  {
    displayName: 'Unmodified Documents',
    reportType: 'unmodifiedDocumentsReport',
    role: ToolsRoles.ViewReports.value,
  },
  {
    displayName: 'User Profile',
    reportType: 'userprofile',
    role: ToolsRoles.RunUserProfileReport.value,
  },
];

export default function UserReportsMenu({
  anchorEl,
  open,
  handleClose,
  setOpenReportsDialog,
  setSelectedReport,
  toolsRoles,
}: UserReportsMenuProps) {
  return (
    <Menu
      id="reports-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'user-reports',
      }}
    >
      {reports.map((report) => (
        <MenuItem
          key={report.displayName}
          onClick={(e) => {
            e.stopPropagation();
            setSelectedReport(report);
            setOpenReportsDialog(true);
            handleClose();
          }}
          disabled={!isAbleToSeeUIElement(toolsRoles, report.role)}
        >
          {report.displayName}
        </MenuItem>
      ))}
    </Menu>
  );
}
